export default string => string.replace(/[^a-f\d]/ig, "");
